/**
 * Tailwind class-name merger with conditional support.
 * Standard shadcn/ui helper.
 */
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
